export enum PageCountEnum {
  THIRTY = "30",
  SIXTY = "60",
  NINTY = "90",
}
